<template>
  <section>
    <v-footer :padless="true">
      <v-card flat tile width="100%" class="text-center">
        <v-card-text class="white--text py-6" style="background-color: #262626;">
          <!-- VERSIÓN DESKTOP -->
          <v-row class="hidden-sm-and-down" align="center">
            <v-col cols="12" md="3" class="d-flex justify-center">
              <v-img src="../assets/footer.png" max-width="250" contain></v-img>
            </v-col>
            <v-col cols="12" md="9">
              <v-row align="center">
                <!-- Pago Seguro -->
                <v-col cols="12" sm="6" md="3">
                  <div class="d-flex align-center justify-center flex-wrap">
                    <font-awesome-icon class="awesome mr-2" :icon="['fas', 'lock']" />
                    <span class="mr-2">{{ $t("pagoseguro") }}</span>
                    <v-img
                      src="@/assets/paycomet.png"
                      max-width="110"
                      height="30"
                      contain
                    ></v-img>
                  </div>
                </v-col>

                <!-- Copyright -->
                <v-col cols="12" sm="6" md="2">
                  <div class="d-flex align-center justify-center flex-wrap">
                    <span class="mr-2">{{ $t("copyright") }}</span>
                    <v-img
                      src="@/assets/equinsa.png"
                      max-width="110"
                      height="30"
                      contain
                    ></v-img>
                  </div>
                </v-col>

                <!-- Aviso Legal -->
                <v-col cols="12" sm="4" md="2">
                  <router-link :to="{ name: 'Terminos' }" class="footer-link">
                    {{ $t("avisolegal") }}
                  </router-link>
                </v-col>

                <!-- Política Cancelación -->
                <v-col cols="12" sm="4" md="3">
                  <router-link :to="{ name: 'Politica_cancelacion' }" class="footer-link">
                    {{ $t("politicaDevolucion") }}
                  </router-link>
                </v-col>

                <!-- Política Privacidad -->
                <v-col cols="12" sm="4" md="2">
                  <router-link :to="{ name: 'Politica_privacidad' }" class="footer-link">
                    {{ $t("politicaprivacidad") }}
                  </router-link>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- VERSIÓN MÓVIL -->
          <div class="hidden-md-and-up">
            <!-- Logo -->
            <v-row class="mb-4">
              <v-col cols="12" class="d-flex justify-center">
                <v-img src="../assets/footer.png" max-width="200" contain></v-img>
              </v-col>
            </v-row>

            <!-- Pago Seguro -->
            <v-row class="mb-3">
              <v-col cols="12">
                <div class="d-flex align-center justify-center flex-column">
                  <div class="d-flex align-center mb-2">
                    <font-awesome-icon class="awesome mr-2" :icon="['fas', 'lock']" />
                    <span>{{ $t("pagoseguro") }}</span>
                  </div>
                  <v-img
                    src="@/assets/paycomet.png"
                    max-width="110"
                    height="30"
                    contain
                  ></v-img>
                </div>
              </v-col>
            </v-row>

            <!-- Copyright -->
            <v-row class="mb-4">
              <v-col cols="12">
                <div class="d-flex align-center justify-center flex-column">
                  <span class="mb-2">{{ $t("copyright") }}</span>
                  <v-img
                    src="@/assets/equinsa.png"
                    max-width="110"
                    height="30"
                    contain
                  ></v-img>
                </div>
              </v-col>
            </v-row>

            <!-- Links legales -->
            <v-row>
              <v-col cols="12" class="py-2">
                <router-link :to="{ name: 'Terminos' }" class="footer-link d-block mb-2">
                  {{ $t("avisolegal") }}
                </router-link>
              </v-col>
              <v-col cols="12" class="py-2">
                <router-link :to="{ name: 'Politica_cancelacion' }" class="footer-link d-block mb-2">
                  {{ $t("politicaDevolucion") }}
                </router-link>
              </v-col>
              <v-col cols="12" class="py-2">
                <router-link :to="{ name: 'Politica_privacidad' }" class="footer-link d-block">
                  {{ $t("politicaprivacidad") }}
                </router-link>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
      </v-card>
    </v-footer>
  </section>
</template>

<style scoped>
.pie {
  font-size: 12px;
  color: white;
}

.borde {
  border-bottom: 1px solid #222222;
}

.awesome,
.awesomeBig {
  color: rgb(76, 175, 241);
}

.awesomeBig {
  font-size: 25px;
}

.bottom-bar {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 100;
}

.footer-link {
  color: white;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.footer-link:hover {
  color: rgb(76, 175, 241);
  text-decoration: underline;
}

/* Estilos responsive */
@media (max-width: 960px) {
  .footer-link {
    font-size: 15px;
    padding: 8px 0;
  }
}
</style>

<script>
import api from "@/plugins/api";

export default {
  components: {},
  data() {
    return {
      click: false,
      nombre: "",
      dialogo: false,
      apellidos: "",
      telefono: "",
      curriculumBase64: "",
      name: "PiePagina",
      terminos: false,
      linkComoLlegarParkingLunaCentro:
        "https://www.google.es/maps/place/Parking+Luna+Centro/@37.171194,-3.6017685,17z/data=!3m1!4b1!4m6!3m5!1s0xd71fdd5288ed97d:0x3cd525c728f6a4b5!8m2!3d37.1711898!4d-3.5991936!16s%2Fg%2F11sb6rty1c?hl=es&entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D",
      linkComoLlegarParkingLunaGranada:
        "https://www.google.es/maps/place/Parking+en+Granada+-+Parking+Luna+de+Granada/@37.1712149,-3.6094933,15z/data=!3m1!5s0xd71fc8d4455b6e7:0x7c909faefdd56afd!4m10!1m2!2m1!1sparking+luna+granada!3m6!1s0xd71fc8d7957a415:0x78aa0b0b5a566f01!8m2!3d37.176514!4d-3.6123517!15sChRwYXJraW5nIGx1bmEgZ3JhbmFkYZIBC3BhcmtpbmdfbG904AEA!16s%2Fg%2F11gd67p3jj?hl=es&entry=ttu&g_ep=EgoyMDI1MDMyNS4xIKXMDSoASAFQAw%3D%3D",
    };
  },
  methods: {
    enviarCorreo() {
      if (
        this.nombre == "" ||
        this.apellidos == "" ||
        this.telefono == "" ||
        this.$estadoApp.archivo == "" ||
        this.terminos == false
      ) {
        this.$root.$dialogo.activarDialogo(
          this.$t("falloCurriculum"),
          this.$t("falloCurriculumDescripcion"),
          ["OK"]
        );
      } else {
        this.click = true;
        api
          .enviarCurriculum(
            this.nombre,
            this.apellidos,
            this.telefono,
            this.curriculumBase64,
            this.$estadoApp.archivo
          )
          .then(() => {
            this.dialogo = false;
            this.$root.$dialogo.activarDialogo(
              this.$t("envioCorrecto"),
              this.$t("envioCorrectoDescripcion"),
              ["OK"]
            );
          })
          .finally(() => {
            this.click = false;
          });
      }
    },
  },
  computed: {
    nombreLabel() {
      return this.$t("nombre");
    },
    apellidosLabel() {
      return this.$t("apellidos");
    },
    telefonoLabel() {
      return this.$t("telefono");
    },
    adjuntaCurriculum() {
      return this.$t("adjuntaCurriculum");
    },
  },
};
</script>